import { atom } from 'recoil'

const systemParametersState = atom<Dto.SystemParameters | undefined>({
  key: 'system-parameters',
  default: undefined,
})

export { systemParametersState }
